import { createBalanceStore } from './create-balance-store';

export const { useBalanceStore, useHasEnoughMinutesToDub, useUploadGate } = createBalanceStore();

export const useIsDownloadRestricted = () => useBalanceStore((state) => !state.hasActiveSubscription);
